module.exports = __webpack_public_path__ + "static/media/search-icon.2973d22b.svg";